export default "__VITE_ASSET__sZXn9YGH__"